import { FC, SVGProps } from "react";

export const PlusIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 22,
  height = 22,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M11.75 8C11.75 7.58579 11.4142 7.25 11 7.25C10.5858 7.25 10.25 7.58579 10.25 8L10.25 10.25H8C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75H10.25V14C10.25 14.4142 10.5858 14.75 11 14.75C11.4142 14.75 11.75 14.4142 11.75 14L11.75 11.75H14C14.4142 11.75 14.75 11.4142 14.75 11C14.75 10.5858 14.4142 10.25 14 10.25H11.75V8Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0574 0.25H10.9426C8.63424 0.249988 6.82519 0.249978 5.41371 0.439747C3.96897 0.633987 2.82895 1.03933 1.93414 1.93414C1.03933 2.82895 0.633987 3.96897 0.439747 5.41371C0.249978 6.82519 0.249988 8.63422 0.25 10.9426V11.0574C0.249988 13.3658 0.249978 15.1748 0.439747 16.5863C0.633987 18.031 1.03933 19.1711 1.93414 20.0659C2.82895 20.9607 3.96897 21.366 5.41371 21.5603C6.82519 21.75 8.63423 21.75 10.9426 21.75H11.0574C13.3658 21.75 15.1748 21.75 16.5863 21.5603C18.031 21.366 19.1711 20.9607 20.0659 20.0659C20.9607 19.1711 21.366 18.031 21.5603 16.5863C21.75 15.1748 21.75 13.3658 21.75 11.0574V10.9426C21.75 8.63423 21.75 6.82519 21.5603 5.41371C21.366 3.96897 20.9607 2.82895 20.0659 1.93414C19.1711 1.03933 18.031 0.633987 16.5863 0.439747C15.1748 0.249978 13.3658 0.249988 11.0574 0.25ZM2.9948 2.9948C3.56445 2.42514 4.33517 2.09825 5.61358 1.92637C6.91356 1.75159 8.62177 1.75 11 1.75C13.3782 1.75 15.0864 1.75159 16.3864 1.92637C17.6648 2.09825 18.4355 2.42514 19.0052 2.9948C19.5749 3.56445 19.9018 4.33517 20.0736 5.61358C20.2484 6.91356 20.25 8.62177 20.25 11C20.25 13.3782 20.2484 15.0864 20.0736 16.3864C19.9018 17.6648 19.5749 18.4355 19.0052 19.0052C18.4355 19.5749 17.6648 19.9018 16.3864 20.0736C15.0864 20.2484 13.3782 20.25 11 20.25C8.62177 20.25 6.91356 20.2484 5.61358 20.0736C4.33517 19.9018 3.56445 19.5749 2.9948 19.0052C2.42514 18.4355 2.09825 17.6648 1.92637 16.3864C1.75159 15.0864 1.75 13.3782 1.75 11C1.75 8.62177 1.75159 6.91356 1.92637 5.61358C2.09825 4.33517 2.42514 3.56445 2.9948 2.9948Z"
        fill={fill}
      />
    </svg>
  );
};
